import React from "react";

import { useTranslation } from "react-i18next";

import { AppDownloadBannerProps } from "./appDownloadBanner.model";
import { redirectTo } from "Utilities/navigation";
import { FontIcon } from "@companion-core/shared/app/Components/FontIcon";
import { getConfig, getModule } from "@companion-core/shared/app/Utils/config";
import { isAppleDevice } from "@companion-core/shared/app/Utils/platform";
import { isTabBarVisible } from "Utilities/tabBar";

import "@companion-core/web/src/Assets/Styles/scss/appDownloadBanner.scss";

export const AppDownloadBanner = ({ onClose, className }: AppDownloadBannerProps) => {
  const { t } = useTranslation();
  const module = getModule("appDownloadBanner");
  const config = getConfig();
  const isDisplayed = isTabBarVisible(config?.options);

  return (
    module?.enabled &&
    isDisplayed && (
      <div
        data-testid="app-download-banner"
        className={`app-download-banner${className ? ` ${className}` : ""}`}>
        <div data-testid="app-download-banner__content" className="app-download-banner__content">
          <button
            data-testid="app-download-banner__close-button"
            onClick={onClose}
            className="app-download-banner__close-button">
            <FontIcon name="JP-Close-bold" size={12} />
          </button>
          <img
            data-testid="app-download-banner__image"
            src={module?.appImageUrl ?? ""}
            alt={t("app-download-banner.image-alt")}
            className="app-download-banner__image"
          />
          <p
            data-testid="app-download-banner__title"
            className="app-download-banner__title body-text-8">
            {t("app-download-banner.title")}
          </p>
          <button
            data-testid="app-download-banner__button"
            className="app-download-banner__store-button body-text-7"
            onClick={() => {
              onClose();
              redirectTo(
                isAppleDevice() ? module?.storeLinks?.ios : module?.storeLinks?.android,
                "external",
                undefined,
                "_self",
              );
            }}>
            {t("app-download-banner.button.text")}
          </button>
        </div>
      </div>
    )
  );
};
